import { Button } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle, Plus } from 'react-feather'

import { LinearLoading } from 'common'
import { DepositTable } from './DepositTable'


export const FormStepDeposit = ({useFetchInit}) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { stepApplilication, formOpeningMode } = globalStates

    const { fetchAllDeposits } = FetchData
    const { loadingFetchDeposits } = fetchAllDeposits

    const { handleClickReturnStep, handleClickNextStep, handleClickShowModal } = Actions

    return (
        <div className='content'>
            <div className="d-flex justify-content-end pt-4">
                <Button
                    startIcon={<Plus/>}
                    variant='contained'
                    sx={{marginBottom: 4, background: "#4b4b4c"}} 
                    onClick={()=>handleClickShowModal('', 'Formulario de depositos', 'ModalDeposit', {}, 'EDITABLE')}
                    disabled={(formOpeningMode==='READONLY')? true : false}
                >
                    Agregar
                </Button>
            </div>
            
            
            {loadingFetchDeposits && ( <LinearLoading /> )}
            <DepositTable
                useFetchInit = {useFetchInit}
            />

            <div className="text-center">
                {stepApplilication !== 0 && (
                    <Button 
                        startIcon={<ArrowLeftCircle/>}
                        variant="contained"
                        type="button" 
                        onClick={handleClickReturnStep} 
                        sx={{ marginRight: 1, marginLeft: 1, background: "#ef8157" }}
                    >
                        Volver
                    </Button>
                )}
                <Button
                    endIcon={<ArrowRightCircle/>}
                    variant="contained"
                    type="button"
                    style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                    onClick={handleClickNextStep}
                >       
                    {stepApplilication === 4 ? 'Finalizar' : 'Continuar'}
                </Button>
            </div>
        </div>
    )
}